import { __, invertObj, prop } from 'ramda';

import { MEDIA_THEMATIC } from '../../../types/filters';

export const PRISMIC_TO_TYPE_MEDIA_THEMATIC = {
  'Transition écologiques': MEDIA_THEMATIC.ECOLOGY,
  'Transformation numérique': MEDIA_THEMATIC.DIGITAL,
  'Services à la personne': MEDIA_THEMATIC.PEOPLE,
  'Banque et assurance': MEDIA_THEMATIC.BANK,
  'Excellence logistique': MEDIA_THEMATIC.LOGISTICS,
  'Développement Territorial': MEDIA_THEMATIC.DT,
  'Ressources humaines': MEDIA_THEMATIC.HUMAN_RESOURCES,
  Philatélie: MEDIA_THEMATIC.PHILATELY,
  Téléphonie: MEDIA_THEMATIC.TELEPHONY,
  Immobilier: MEDIA_THEMATIC.REAL_ESTATE,
  International: MEDIA_THEMATIC.INTERNATIONAL,
  Evènement: MEDIA_THEMATIC.EVENT,
  Finances: MEDIA_THEMATIC.FINANCIAL,
};

export const toMediaThematicType = prop(__, PRISMIC_TO_TYPE_MEDIA_THEMATIC);
export const toMediaThematicPrismic = prop(
  __,
  invertObj(PRISMIC_TO_TYPE_MEDIA_THEMATIC)
);
